import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ComponentDefinition } from '../../../models';
import { languages } from '../../../common/';

interface ILanguageElement {
    id: number; // 0, 1, 2...
    key: string; // en, fr, ru... 
    text: string; // english, french, russian...
    flagIcon: string; // flag-icon-gb, flag-icon-fr...
}

class LanguagePickerController implements angular.IComponentController {
    static controllerId = 'wtLanguagePicker';

    languages: ILanguageElement[];
    language: ILanguageElement;

    private _unsubscribe: () => void;

    static $inject = ['$rootScope', '$translate'];

    constructor(
        private $rootScope: angular.IRootScopeService,
        private $translate: angular.translate.ITranslateService
    ) {
        this.languages = languages;
        this._unsubscribe = this.$rootScope.$on('$translateChangeSuccess', () => {
            this.language = this.getLanguage();
        });
    }

    $onInit() {
        // nothing
    }

    $onDestroy() {
        this._unsubscribe();
    }

    setLanguage(key: string): void {
        moment.locale(key);
        this.$translate.use(key);
    }

    private getLanguage(index?: number): ILanguageElement {
        const lang = this.$translate.use();
        const result = index
            ? this.languages[index]
            : _.find(this.languages, d => d.key === lang);
        if (lang) {
            moment.locale(lang);
            document.documentElement.setAttribute('lang', lang);
        }
        return result;
    }
}

export const wtLanguagePicker: ComponentDefinition = {
    componentId: 'wtLanguagePicker',
    controller: LanguagePickerController,
    template: require('./languagePicker.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {

    }
};
